import {getNumberFromInput} from '../../../record-editing';
import {
    Label,
    LabelContainer,
    NumberControlShowingEdits,
    ValidationsList
} from '../../../components/Form/FormStyles';
import {EditedProject} from '../EditedProject';
import {NumericFormFieldContainer} from './NumericFormFieldContainer';

export function ProposedProjectCostControl({
    project,
    setProjectAndValidate
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
}) {
    return (
        <NumericFormFieldContainer>
            <LabelContainer>
                <Label htmlFor="proposedProjectCost">Proposed project cost</Label>
            </LabelContainer>
            <NumberControlShowingEdits
                id="proposedProjectCost"
                value={project.ProposedProjectCost}
                onChange={(e) =>
                    setProjectAndValidate({
                        ...project,
                        ProposedProjectCost: project.ProposedProjectCost.update(getNumberFromInput(e))
                    })
                }></NumberControlShowingEdits>
            <ValidationsList validations={project.ProposedProjectCost.validations} />
        </NumericFormFieldContainer>
    );
}
